'use strict';

angular.module('TurneroApp').service('encuestaService', ['$resource', 'portal', function ($resource, portal) {
	return $resource(portal.getUrlServer() + 'api/Pregunta/:id', { id: '@id' }, {
		Get_Preguntas_Turno: {
			method: 'GET',
			params: {
				id_opcion_calificacion: '@id_opcion_calificacion'
			},
			url: portal.getUrlServer() + 'api/Pregunta/Get_Preguntas_Turno'
		},
        Guardar_Respuestas: {
			method: 'POST',
			params: {
				Id_Turno: '@Id_Turno'
			},
            url: portal.getUrlServer() + 'api/Pregunta/Guardar_Respuestas'
		},
	});
}]);



// WEBPACK FOOTER //
// ./app/components/layout/encuestas/encuestas-service.js